<!--
  This is a wrapper for the actual vue-multiselect. Props, events and slots are forwarded.
-->

<template>
  <multi-select v-bind="$attrs" v-on="$listeners">
    <template v-for="(_, slot) of $scopedSlots" #[slot]="scope">
      <slot :name="slot" v-bind="scope" />
    </template>
  </multi-select>
</template>

<script>
import MultiSelect from "vue-multiselect";

export default {
  components: {
    MultiSelect,
  },
  props: {
    noResultsLabel: {
      type: String,
      default: 'No search results.',
    },
  },
  /**
   * On mount, this wrapper manually fixes the text shown on the no-result label, also setting a css class.
   * This is necessary as vue-multiselect provides no prop or even data to control this message - it is hard-coded.
   */
  mounted() {
    const no_result_el = [...this.$el.querySelectorAll(`.multiselect__option`)]
      .find(el => el.textContent.match(/no elements found/gi));

    if (this.noResultsLabel && no_result_el) {
      no_result_el.textContent = this.noResultsLabel;
      no_result_el.classList.add('multiselect__no-results-label');
    }
  },
};
</script>

<style lang="scss">
@use "sass:map";

@use 'AssetsSass/_variables' as *;

.multiselect {
	.multiselect__placeholder, .multiselect__input {
		font-size: 13px !important;
		font-weight: 400 !important;
		color: rgba(73, 80, 87, 0.8) !important;
		line-height: 1.5;
	}

	.multiselect__option--highlight {
		background: map.get($ss, 'secondary');

		&::after {
			background: map.get($ss, 'secondary');
		}
	}

	.multiselect__option--selected {
		&.multiselect__option--highlight {
			background: map.get($ss-theme, 'tomato-red');

			&::after {
				background: map.get($ss-theme, 'tomato-red');
			}
		}
	}
}

.multiselect__single {
	font-size: 14px !important;
	font-weight: 500;
}

.multiselect__no-results-label {
  font-style: italic;
}
</style>
